import { SectionView } from 'mappMvc/models/views';
import { IMApp } from 'mappClient/models';
import { MAppList, MobileApp } from '.';
import { ID, Icons } from '../../../const';
import { IView } from 'mappMvc/interfaces';
import { ViewOptions } from 'mappMvc/interfaces/options';
import { Localization } from 'mappMvc/compile';

export class MAppSection extends SectionView<IMApp> {
	mappList: MAppList;
	mobileApp: MobileApp;

	constructor() {
		super(<ViewOptions>{
			viewId: ID.MApps,
			label: Localization.License.MApps,
			icon: Icons.MApps
		});

		var views: IView[] = [];
		this.mappList = new MAppList({ parent: this });
		views.push(this.mappList);

		this.mobileApp = new MobileApp({ parent: this });
		views.push(this.mobileApp);

		this.defaultView = this.mappList;
		this.initViews(views);
	}

	public new() {
		throw new Error(Localization.Errors.NotImplemented);
	}

	public list() {
		throw new Error(Localization.Errors.NotImplemented);
	}
}
